export const gpWinLoseAllowList = ['1','5', '500999'];
